import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteName, siteSlogan } from '@/mocks/siteData';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '游戏库', to: '/games' },
  { label: '结局攻略', to: '/endings' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className={`font-heading text-lg font-bold tracking-wide ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
            {siteName}
          </span>
        </Link>

        <ul className="hidden items-center gap-8 md:flex">
          {navLinks.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                className={`text-sm whitespace-nowrap transition-colors ${
                  scrolled
                    ? location.pathname === l.to
                      ? 'text-primary-600 font-bold'
                      : 'text-foreground-700 hover:text-primary-600'
                    : location.pathname === l.to
                    ? 'text-accent-300 font-bold'
                    : 'text-background-100/90 hover:text-accent-200'
                }`}
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>

        <Link
          to="/games"
          className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-bold transition-colors md:inline-flex ${
            scrolled
              ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
              : 'bg-accent-500 text-foreground-950 hover:bg-accent-400'
          }`}
        >
          找攻略
        </Link>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            scrolled ? 'text-foreground-900' : 'text-background-50'
          }`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <ul className="space-y-1">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="block rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-2 px-3 font-label text-xs text-foreground-500">{siteSlogan}</p>
        </div>
      )}
    </header>
  );
}